import { exhangeShopApi } from '../../api/exchangeShop';
const { getGoodsDetails, buyGoods, getJszxOverview } = exhangeShopApi;

export default {
  data() {
    const isMobile = location.href.indexOf('/m/') != -1;
    const checkoutPhone = (rule, value, callback) => {
      let reg =
        /^(13[0-9]|14[01456879]|15[0-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (isMobile) {
        let Temp = value;
        value = rule;
        rule = Temp;
      }
      if (!value) {
        if (isMobile) {
          this.$toast('手机号不能为空');
          return false;
        }
        return callback(new Error('手机号不能为空'));
      } else if (reg.test(value)) {
        if (isMobile) return true;
        callback();
      } else {
        if (isMobile) {
          this.$toast('请输入正确的手机号');
          return false;
        }
        return callback(new Error('请输入正确的手机号'));
      }
    };
    const checkAdress = (rule, value, callback) => {
      let reg = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
      if (isMobile) {
        let Temp = value;
        value = rule;
        rule = Temp;
      }
      if (!value) {
        if (isMobile) {
          this.$toast('地址不能为空');
          return false;
        }
        return callback(new Error('地址不能为空'));
      } else if (reg.test(value)) {
        if (isMobile) return true;
        callback();
      } else {
        if (isMobile) {
          this.$toast('地址只能使用中文、英文、数字填写');
          return false;
        }
        return callback(new Error('地址只能使用中文、英文、数字填写'));
      }
    };
    return {
      name: '',
      txt: '',
      sell_num: 0,
      buy_num: 0,
      myExchangedNums: 0,
      id: 0,
      image: '',
      month_buy: 0,
      price: 0,
      stock: 0,
      // btnDisabled: false,
      showExchangeDialog: false,
      exchanging: false, // 请求兑换中
      state: 0,
      balance: 0,
      type: 0, // 商品类型：1实物、2虚拟道具、3迷你币
      virtualExchangeTips:
        '兑换成功，物品将通过邮件发放至您的账号内，请注意查收',
      entityExchangeTips:
        '已提交兑换订单，审核通过后将安排发货，可通过查询订单查看订单状态',
      form: {
        name: '',
        provincesCity: '',
        address: '',
        phone: '',
      },
      rules: {
        name: [
          { required: true, message: '请填写收货人姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字', trigger: 'blur' },
        ],
        provincesCity: [
          { required: true, message: '请正确填写省市', trigger: 'blur' },
          { min: 4, max: 20, message: '长度在 4 到 20 个字', trigger: 'blur' },
        ],
        address: [
          {
            required: true,
            message: '请正确填写收货地址(不支持特殊符号、回车换行等)',
            trigger: 'blur',
            validator: checkAdress,
          },
          { min: 5, max: 30, message: '长度在 5 到 30 个字', trigger: 'blur' },
        ],
        phone: [
          {
            required: true,
            message: '请填写收货人手机号',
            trigger: 'blur',
            validator: checkoutPhone,
          },
        ],
      },
    };
  },
  computed: {
    btnDisabled() {
      if (this.stock === 0 || this.stock === 9999) return false;
      return (
        this.stock - this.sell_num <= 0 ||
        (this.month_buy > 0 && this.buy_num >= this.month_buy)
      );
    },
  },
  created() {
    this.getJszxMoney();
    let addressInfo = localStorage.getItem('kfz_exchangeShop_adressInfo') || '';
    if (addressInfo) {
      addressInfo = JSON.parse(addressInfo);
      const { name, phone, provincesCity, address } = addressInfo;
      this.form.name = name;
      this.form.phone = phone;
      this.form.provincesCity = provincesCity;
      this.form.address = address;
    }
  },
  mounted() {
    console.log('商品详情', this.$route.query);
    const { name, txt, sell_num, id, image, month_buy, price, stock } =
      this.$route.query;
    this.name = name || '';
    this.txt = txt || '';
    this.sell_num = sell_num || 0;
    this.id = id || 0;
    this.image = image || '';
    this.month_buy = month_buy || 0;
    this.price = price || 0;
    this.stock = stock || 9999;
    this.getGoodsDetails(id);
  },
  methods: {
    getJszxMoney() {
      getJszxOverview({ dtype: 1 }).then(res => {
        if (res.code === 0) {
          this.balance = res.data.money;
        }
      });
    },
    getGoodsDetails(id) {
      getGoodsDetails({ id }).then(res => {
        console.log('商品详情----', res);
        if (res.code === 0) {
          const {
            image,
            month_buy,
            name,
            price,
            state,
            stock,
            type,
            txt,
            buy_num,
            sell_num,
          } = res.data;
          this.image = image;
          this.month_buy = month_buy;
          this.name = name;
          this.price = price;
          this.state = state;
          this.stock = stock || 9999;
          this.txt = (txt || '').replace(/\n/g, '<br />');
          this.type = type;
          this.buy_num = buy_num;
          this.sell_num = sell_num;
        }
      });
    },
    exchangeBtnClicked() {
      console.log('exchangeBtnClicked---');
      this.Report('click', 'RedemptionButton', { v3: this.id });
      if (this.btnDisabled) {
        if (this.stock - this.sell_num <= 0) {
          return this.$message
            ? this.$message.error('库存不足')
            : this.$toast.fail('库存不足');
        }
        if (this.month_buy > 0 && this.buy_num >= this.month_buy) {
          return this.$message
            ? this.$message.error('已达兑换上限')
            : this.$toast.fail('已达兑换上限');
        }
        return;
      }
      if (this.balance <= 0 || this.balance < this.price) {
        return this.$message
          ? this.$message.error('余额不足')
          : this.$toast.fail('余额不足');
      }
      if (this.type === 1) {
        this.showExchangeDialog = true;
      } else {
        if (this.$confirm) {
          this.$confirm(`即将兑换商品${this.name}?`, '兑换确认', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              this.buyGoodsHandle(() => {
                this.$message
                  ? this.$message.success(this.virtualExchangeTips)
                  : this.$toast(this.virtualExchangeTips);
              });
            })
            .catch(() => {});
        } else if (this.$dialog && this.$dialog.confirm) {
          this.$dialog
            .confirm({
              title: '兑换确认',
              message: `即将兑换商品${this.name}?`,
            })
            .then(() => {
              this.buyGoodsHandle(() => {
                this.$message
                  ? this.$message.success(this.virtualExchangeTips)
                  : this.$toast(this.virtualExchangeTips);
              });
            })
            .catch(() => {});
        }
      }
    },
    backToHome() {
      this.$router.push({ name: 'ESHome' });
    },
    buyGoodsHandle(responseHandle) {
      let params = { id: this.id };
      if (this.type === 1) {
        const { name, phone, provincesCity, address } = this.form;
        params = {
          ...params,
          buyer_name: name,
          buyer_phone: phone,
          buyer_address: provincesCity + address,
        };
        localStorage.setItem(
          'kfz_exchangeShop_adressInfo',
          JSON.stringify({ name, phone, provincesCity, address }),
        );
      }
      if (this.exchanging) return;
      this.exchanging = true;
      buyGoods(params)
        .then(res => {
          if (res.code === 0) {
            if (responseHandle) {
              responseHandle();
            } else {
              this.$message
                ? this.$message.success(
                    this.type === 1 ? this.entityExchangeTips : '兑换成功',
                  )
                : this.$toast(
                    this.type === 1 ? this.entityExchangeTips : '兑换成功',
                  );
              this.showExchangeDialog = false;
            }
            this.getGoodsDetails(this.id);
          } else {
            this.$message
              ? this.$message.error(res.msg || '兑换失败')
              : this.$toast.fail(res.msg || '兑换失败');
          }
          setTimeout(() => {
            this.exchanging = false;
          }, 200);
        })
        .catch(err => {
          console.error(err);
          this.exchanging = false;
        });
    },
    onSubmit() {
      // eslint-disable-next-line no-undef
      const validate = this.$refs.adressForm.validate;
      if (this.$route.meta.device === 'mobile') {
        validate().then(() => {
          this.buyGoodsHandle();
        });
      } else {
        validate(valid => {
          if (valid) {
            this.buyGoodsHandle();
          } else {
            console.error('error submit!!!');
            return false;
          }
        });
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
